import { Component, OnInit } from '@angular/core';
import { DialogRef } from '../dialog-ref';
import { DialogConfig } from '../dialog-config';

@Component({
  selector: 'app-common-error-message-drawer',
  templateUrl: './common-error-message-drawer.component.html',
  styleUrls: ['./common-error-message-drawer.component.scss']
})
export class CommonErrorMessageDrawerComponent implements OnInit {
  public textData;
  public title;
  constructor(
    public dialogRef: DialogRef,
    private dialogConfig: DialogConfig
  ) { }

  ngOnInit(): void {
    const data = this.dialogConfig['data'];
    this.textData = data.desc;
    this.title = data.title;
  }
}
